'use client'

import NextLink from '@/components/NextLink';
import Button from '@/components/ui/Button';
import { useItineraryStoreV2 } from '@/core/stores/itinerary/itineraryV2';
import { ItineraryDayV2 } from '@/types/itinerary/itineraryV2';
import { generateColor } from '@/utils/generateColor';
import { useParams, } from 'next/navigation';
import { useEffect } from 'react';
import ItineraryMobileNavbar from '../components/ItineraryMobileNavbar';

export default function Tabs({ itineraryId, days }: { itineraryId: string, days: ItineraryDayV2[] }) {

    const { day } = useParams();

    const { setActiveDays, setShowActivities, setShowHotels, baseUrl } = useItineraryStoreV2()

    useEffect(() => {
        if (days && days.length > 0) {
            setActiveDays(days.map((_, index) => index))
        }
        setShowHotels(false)
        setShowActivities(false)
    }, [days, setActiveDays, setShowActivities, setShowHotels])

    return (
        <>
            <div className="w-full relative z-10">

                <ItineraryMobileNavbar className='px-4' />

                <div className="hidden md:block py-4 w-full overflow-x-auto  px-4">
                    <div className="flex min-h-fit gap-1">
                        <NextLink
                            href={baseUrl}
                            className={`${!day ? "border-primary-800 text-primary-800" : "border-primary-700/0  text-gray-700 "}
                                 `}
                        >
                            <Button isActive={!day} size='small' color={'ghost'}>
                                Overview
                            </Button>
                        </NextLink>
                        {days.map((item, index) => (
                            <NextLink
                                key={index}
                                href={`${baseUrl}/days/${index + 1}`}
                                style={{
                                    borderColor: Number(day) - 1 === index ? generateColor(index + 1) : "#00000000",
                                    color: Number(day) - 1 === index ? generateColor(index + 1) : "#374151",
                                }}
                                className={'min-w-fit'}>

                                <Button isActive={Number(day) - 1 === index} size='small' color={'ghost'}>
                                    {`Day ${index + 1}`}
                                </Button>

                            </NextLink>
                        ))}
                    </div>
                </div>
            </div>
        </>
    )
}
